import React from "react";

import { houseNumberValidationPattern } from "@gp/common";

import { FormInputField } from "@components-shared/desktop/inputs";

export default function OnboardingRegistrationHouseNumber(props: {
	labelClassName?: string;
}) {
	const { labelClassName } = props;

	return (
		<FormInputField
			id="houseNumber"
			name="houseNumber"
			className="form__field u-mar--bottom--reset"
			labelClassName={labelClassName}
			label="registration:HOUSE_NUMBER_LABEL"
			inputClassName="input input--sml"
			placeholder="registration:HOUSE_NUMBER_PLACEHOLDER"
			pattern={{
				value: houseNumberValidationPattern,
				message: "registration:INVALID_HOUSE_NUMBER",
			}}
			required
		/>
	);
}
